import { render, staticRenderFns } from "./TechPanes.vue?vue&type=template&id=30c087ce&"
import script from "./TechPanes.vue?vue&type=script&lang=ts&"
export * from "./TechPanes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports